import { AppRegistry } from "react-native";
import App from "./App";
import Storage from "react-native-storage";

const storage = new Storage({
  storageBackend: localStorage,
  defaultExpires: null,
});

window.storage = storage;
global.storage = storage;

// generate required css
import fontAwesome from "react-native-vector-icons/Fonts/FontAwesome.ttf";
const reactNativeVectorIconsRequiredStyles =
  "@font-face { src:url(" + fontAwesome + ");font-family: FontAwesome; }";

// create stylesheet
const style = document.createElement("style");
style.type = "text/css";
if (style.styleSheet) {
  style.styleSheet.cssText = reactNativeVectorIconsRequiredStyles;
} else {
  style.appendChild(
    document.createTextNode(reactNativeVectorIconsRequiredStyles)
  );
}

// inject stylesheet
document.head.appendChild(style);

// object.keys polyfill
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
  Object.keys = (function () {
    var hasOwnProperty = Object.prototype.hasOwnProperty,
      hasDontEnumBug = !{ toString: null }.propertyIsEnumerable("toString"),
      dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor",
      ],
      dontEnumsLength = dontEnums.length;

    return function (obj) {
      if (
        typeof obj !== "function" &&
        (typeof obj !== "object" || obj === null)
      ) {
        throw new TypeError("Object.keys called on non-object");
      }

      var result = [],
        prop,
        i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  })();
}

// object.values polyfill
const reduce = Function.bind.call(Function.call, Array.prototype.reduce);
const isEnumerable = Function.bind.call(
  Function.call,
  Object.prototype.propertyIsEnumerable
);
const concat = Function.bind.call(Function.call, Array.prototype.concat);

if (!Object.values) {
  Object.values = function values(O) {
    return reduce(
      Object.keys(O),
      (v, k) =>
        concat(v, typeof k === "string" && isEnumerable(O, k) ? [O[k]] : []),
      []
    );
  };
}

if (!Object.entries) {
  Object.entries = function entries(O) {
    return reduce(
      Object.keys(O),
      (e, k) =>
        concat(
          e,
          typeof k === "string" && isEnumerable(O, k) ? [[k, O[k]]] : []
        ),
      []
    );
  };
}

// App registration and rendering
AppRegistry.registerComponent("MyApp", () => App);
AppRegistry.runApplication("MyApp", {
  rootTag: document.getElementById("root"),
});



// WEBPACK FOOTER //
// ./src/index.js